'use strict';

import React from 'react';
import FaFacebook from 'react-icons/lib/fa/facebook';

require('styles//FloatingButtons.css');

class FloatingButtonsComponent extends React.Component {
  render() {
    return (
      <div className="floatingbuttons-component">
        <a href="https://linkedin.com/company/laborteamlda" className="floatingbutton linkedin">
          <svg id="uuid-914f033a-2920-4db4-9339-16d9c66623ab" viewBox="0 0 72 36">
            <g>
              <path
                d="M46.29,22.29h-1.6v-.68h-.02c-.36.41-.97.75-2.02.75-1.43,0-2.66-1.07-2.66-2.92s1.21-2.93,2.71-2.93c.93,0,1.51.33,1.85.75h.02v-3.54h1.71v8.57ZM43.13,17.79c-.98,0-1.53.7-1.53,1.63s.55,1.66,1.53,1.66,1.55-.71,1.55-1.66-.57-1.63-1.55-1.63ZM39.23,21.37c-.4.52-1.24.99-2.58.99-1.79,0-2.94-1.19-2.94-3.06,0-1.66,1.03-2.8,2.99-2.8,1.69,0,2.73,1.11,2.73,3.06,0,.19-.03.39-.03.39h-4.07v.18c.12.49.49,1.09,1.35,1.09.75,0,1.26-.4,1.49-.71l1.07.87h0ZM37.78,18.86c.01-.6-.43-1.21-1.13-1.21-.83,0-1.27.65-1.32,1.21h2.45,0Z"
                style={{ fill: 'currentColor', strokeWidth: '0px' }} />
              <path
                d="M33.71,16.57h-2l-2,2.29v-5.14h-1.71v8.57h1.71v-2.86l2.11,2.86h2.02l-2.42-3.12,2.29-2.59ZM21.14,16.57h1.62v.82h.02c.25-.44.97-.89,1.87-.89,1.73,0,2.21,1.1,2.21,2.61v3.17h-1.71v-2.86c0-.84-.3-1.43-1.01-1.43-.86,0-1.27.68-1.27,1.54v2.74h-1.71v-5.71ZM18.29,22.29h1.71v-5.71h-1.71v5.71ZM19.14,15.6c.57.01,1.04-.44,1.05-1,.01-.57-.44-1.04-1-1.05-.02,0-.03,0-.05,0-.57.01-1.02.48-1,1.05.01.55.45.99,1,1ZM13.71,13.71h-1.71v8.57h5.14v-1.71h-3.43v-6.86Z"
                style={{ fill: 'currentColor', strokeWidth: '0px' }} />
              <path
                d="M59.13,12h-10.23c-.49,0-.9.39-.9.86v10.27c0,.48.27.86.76.86h10.23c.49,0,1.01-.39,1.01-.86v-10.27c0-.48-.38-.86-.87-.86ZM52.57,16.57h1.62v.82h.02c.25-.44.97-.89,1.87-.89,1.73,0,2.21.92,2.21,2.61v3.17h-1.71v-2.86c0-.76-.3-1.43-1.01-1.43-.86,0-1.27.58-1.27,1.54v2.74h-1.71v-5.71ZM49.71,22.29h1.71v-5.71h-1.71v5.71ZM51.64,14.57c0,.59-.48,1.07-1.07,1.07s-1.07-.48-1.07-1.07c0-.59.48-1.07,1.07-1.07s1.07.48,1.07,1.07Z"
                style={{ fill: 'currentColor', fillRule: 'evenodd', strokeWidth: '0px' }} />
            </g>
          </svg>
        </a>
        <a href="/static/downloads/floating-buttons/Supremo_LT_Windows.exe" className="floatingbutton supremo">
          <svg id="uuid-d737b4e3-ff9e-4f56-a2c7-567935cc76ea" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 72 36">
            <path
              d="M17.99,11.12c-3.84,0-6.94,3.09-6.94,6.88s3.1,6.88,6.94,6.88,6.95-3.09,6.95-6.88-3.11-6.88-6.95-6.88ZM9.94,18c0-4.42,3.61-8,8.05-8s8.06,3.58,8.06,8-3.62,8-8.06,8-8.05-3.58-8.05-8Z"
              style={{ fill: 'currentColor', fillRule: 'evenodd', strokeWidth: '0px' }} />
            <path
              d="M17.37,12.74c.21-.38.76-.39.97,0l3.58,6.42c.21.37-.06.83-.49.83h-7.1c-.42,0-.69-.45-.49-.83l3.52-6.42Z"
              style={{ fill: 'currentColor', strokeWidth: '0px' }} />
            <path
              d="M13.03,20.98c-.13,0-.2.14-.13.25l.18.24.19.23.2.22.21.22.22.21.22.19.23.18.24.17.25.16.25.15.26.13.26.12.27.11.27.1.28.08.27.07.28.06.28.04.28.03.28.02h.28l.28-.02.28-.03.28-.04.28-.06.27-.07.28-.08.27-.1.27-.11.26-.12.26-.13.25-.15.25-.16.24-.17.23-.18.22-.19.22-.21.21-.22.2-.22.19-.23.18-.24c.07-.11,0-.25-.13-.25h-9.79Z"
              style={{ fill: 'currentColor', strokeWidth: '0px' }} />
            <circle cx="18" cy="18" r="18" style={{ fill: 'none', strokeWidth: '0px' }} />
            <path
              d="M46,10h7.58v7.58h-7.58v-7.58ZM54.42,10h7.58v7.58h-7.58v-7.58ZM46,18.42h7.58v7.58h-7.58v-7.58ZM54.42,18.42h7.58v7.58h-7.58"
              style={{ fill: 'currentColor', strokeWidth: '0px' }} />
            <circle cx="54" cy="18" r="18" style={{ fill: 'none', strokeWidth: '0px' }} />
            <line x1="36" y1="5.68" x2="36" y2="29.68" style={{ fill: 'none', stroke: 'currentColor', strokeMiterlimit: '10' }} />
          </svg>
        </a>
      </div>
    );
  }
}

FloatingButtonsComponent.displayName = 'FloatingButtonsComponent';

// Uncomment properties you need
// FloatingButtonsComponent.propTypes = {};
// FloatingButtonsComponent.defaultProps = {};

export default FloatingButtonsComponent;



// WEBPACK FOOTER //
// ./src/components/FloatingButtonsComponent.js